import React from 'react';
import { UserSwitch } from '@phosphor-icons/react';
import { useNavigate } from 'react-router-dom';

import { ProfileIcon } from '..';

import { trackLogOut } from '../../../../analytics';

import { URL } from '../../../../constants';

import useAuthUserStore from '../../../../hooks/useAuthUserStore';

import { unsetUserID } from '../../../../services/googleAnalyticsService';
import { restartSessionLR } from '../../../../services/logrocketService';

import { goTo } from '../../../../utils';

import { Dropdown, Badge } from '../../../general';

const ProfileDropdown = () => {
  const { user, adminMode } = useAuthUserStore();

  const navigate = useNavigate();

  const isAttendeePortal = window.location.pathname.includes(
    URL.ATTENDEE_PORTAL,
  );

  const onClickLogOut = () => {
    localStorage.clear();
    sessionStorage.clear();

    unsetUserID();
    trackLogOut();

    restartSessionLR();

    goTo(URL.LOGIN);
  };

  return (
    <Dropdown
      btnData={{ icon: <ProfileIcon />, colour: 'custom' }}
      menuItems={[
        {
          type: 'custom',
          customContent: (
            <div className="w-80 px-4 py-1">
              {(user.firstName || user.lastName) && (
                <div className="flex gap-1 items-center font-bold break-all ">
                  <div>
                    {user.firstName} {user.lastName}
                  </div>
                  {adminMode && <Badge variant="grey" size="sm" text="Admin" />}
                </div>
              )}

              {user.email && (
                <div className="text-xs break-all opacity-50">{user.email}</div>
              )}
            </div>
          ),
        },
        {
          // for demo purposes only
          label: `Switch to ${isAttendeePortal ? 'host' : 'attendee'} view`,
          icon: <UserSwitch />,
          onClick: () =>
            navigate(isAttendeePortal ? URL.HOME : URL.ATTENDEE_PORTAL),
          show: user.email.includes('+attendee@crowdclip.com'),
        },
        { type: 'divider' },
        { label: 'Log Out', onClick: onClickLogOut, closeOnClick: true },
      ]}
      position="right"
    />
  );
};

export default ProfileDropdown;
